import type { Translation } from "@/i18n/locales/types";

export const errors: Translation["errors"] = {
  notFoundTitle: "Page not found",
  notFoundDescription: "The address does not exist or is no longer available.",
  forbiddenTitle: "No access",
  forbiddenDescription: "You don't have permission to see this page.",
  backHome: "Back to home",
  unexpectedTitle: "Something went wrong",
  unexpectedDescription:
    "Please try again. If it keeps happening, contact support.",
  reloadDescription:
    "Reload the page. If the problem persists, contact support.",
  network: "Could not reach the server.",
};
